import Reveal from "@/components/Reveal";
import { Milestone as MilestoneIcon, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const Milestone = () => (
  <section id="milestone" className="relative py-8 lg:py-12" data-testid="milestone-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div
          className="relative overflow-hidden border border-dashed border-gold/40 rounded-md bg-gold/[0.04] px-6 py-6 sm:px-9 sm:py-7 flex flex-col sm:flex-row sm:items-center gap-5"
          data-testid="milestone-strip"
        >
          <div className="flex items-center gap-3 shrink-0">
            <span className="relative flex w-2.5 h-2.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-gold opacity-60 animate-ping" />
              <span className="relative inline-flex rounded-full w-2.5 h-2.5 bg-gold" />
            </span>
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold">Milestone Incoming</span>
          </div>
          <p className="flex-1 text-sm text-slate-300 leading-relaxed" data-testid="milestone-text">
            When ATLAS Analysis reaches <span className="text-gold font-semibold">200 members</span>, a community
            giveaway unlocks — the ATLAS Indicator plus <span className="text-gold font-semibold">Lifetime Exclusive
            Access</span>. Invite 3 genuine members to qualify.
          </p>
          <Link
            to="/giveaway"
            data-testid="milestone-giveaway-link"
            className="group inline-flex shrink-0 items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase border border-gold/40 text-gold px-4 py-2.5 rounded-sm hover:bg-gold hover:text-ink transition-colors duration-300"
          >
            <MilestoneIcon size={12} />
            View The Giveaway
            <ArrowRight size={12} className="transition-transform duration-300 group-hover:translate-x-0.5" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Milestone;
